export default "__VITE_ASSET__BshVLIzd__"